import { _persianDigit } from './persianDigit';

export function _priceDigit(number?: number | string, decimalSeparator = '.') {
    // Return undefined or null if no number is provided
    if (!number) return number;

    // Convert number to string if it's a number
    if (typeof number === 'number') {
        number = number.toString();
    }

    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = number.split('.');

    // Format the integer part with commas for thousands and convert to Persian digits
    const formattedIntegerPart = _persianDigit(integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    // Construct the result, using the specified decimal separator if a decimal part exists
    const result = number.includes('.')
        ? `${formattedIntegerPart}${decimalSeparator}${decimalPart}`
        : formattedIntegerPart;

    // Return the final formatted price in Persian digits
    return _persianDigit(result);
}

export function _plainNumber(formattedPrice?: string, decimalSeparator = '.') {
    // Return undefined or null if no formatted price is provided
    if (!formattedPrice) return formattedPrice;

    // Remove Persian digits and replace them with standard digits
    const standardDigits = formattedPrice
        .replace(/۰/g, '0')
        .replace(/۱/g, '1')
        .replace(/۲/g, '2')
        .replace(/۳/g, '3')
        .replace(/۴/g, '4')
        .replace(/۵/g, '5')
        .replace(/۶/g, '6')
        .replace(/۷/g, '7')
        .replace(/۸/g, '8')
        .replace(/۹/g, '9');

    // Remove Persian commas and standard commas
    // const withoutCommas = standardDigits.replace(/[٬,]/g, '');

    // Replace the decimal separator with a dot if necessary
    // const result = withoutCommas.replace(new RegExp(`\\${decimalSeparator}`, 'g'), '.');

    // Return the final plain number string
    return standardDigits;
}
